import { PermissionString, Role, Permission } from './types'

export class PermissionResolver {
  private roles: Role[]
  private _validPermissions: Permission[] | null = null

  constructor(roles: Role[]) {
    this.roles = roles
  }

  private get validPermissions(): Permission[] {
    if (this._validPermissions === null) {
      this._validPermissions = this.roles
        .filter(role => role.permissions && role.permissions.length > 0)
        .flatMap(role => role.permissions)
        .filter(perm => perm.actions && perm.actions.length > 0)
    }

    return this._validPermissions
  }

  hasPermission(permission: PermissionString): boolean {
    const [resourcePart, ...subResources] = permission.split(':')
    const action = subResources.length > 0 ? subResources.join(':') : undefined

    return (
      this.validPermissions.find(perm => {
        if (
          perm.resource === resourcePart &&
          action &&
          perm.actions!.includes(action)
        ) {
          return true
        }

        return this.checkHierarchicalAccess(perm, resourcePart, action)
      }) !== undefined
    )
  }

  private checkHierarchicalAccess(
    perm: Permission,
    requestedResource: string,
    requestedAction?: string
  ): boolean {
    // Check if perm.resource is a parent of requestedResource
    if (requestedResource.startsWith(perm.resource + '.')) {
      // Parent has specific actions → grants same actions to children
      return requestedAction ? perm.actions!.includes(requestedAction) : false
    }

    return false
  }

  checkMultiple(
    permissions: PermissionString[]
  ): Record<PermissionString, boolean> {
    return permissions.reduce(
      (acc, permission) => ({
        ...acc,
        [permission]: this.hasPermission(permission)
      }),
      {} as Record<PermissionString, boolean>
    )
  }
}
